import { createContext, useState } from 'react';

export interface SelfContextProps {
  self: boolean;
  setSelf: (option: boolean) => void;
}

export const SelfContext = createContext<SelfContextProps>({
  self: false,
  setSelf: () => { }
})

export function SelfContextProvider(props: { children: React.ReactNode }) {
  const [self, setSelf] = useState<boolean>(false)

  return (
    <SelfContext.Provider value={{ self, setSelf }}>
      {props.children}
    </SelfContext.Provider>
  )
} 